import { render, staticRenderFns } from "./AddressDom.vue?vue&type=template&id=7f06a01a&scoped=true&"
import script from "./AddressDom.vue?vue&type=script&lang=js&"
export * from "./AddressDom.vue?vue&type=script&lang=js&"
import style0 from "./AddressDom.vue?vue&type=style&index=0&id=7f06a01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f06a01a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f06a01a')) {
      api.createRecord('7f06a01a', component.options)
    } else {
      api.reload('7f06a01a', component.options)
    }
    module.hot.accept("./AddressDom.vue?vue&type=template&id=7f06a01a&scoped=true&", function () {
      api.rerender('7f06a01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/forms/AddressDom.vue"
export default component.exports